/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./NftMallSortFilter.vue?vue&type=template&id=60d932be&scoped=true"
import script from "./NftMallSortFilter.vue?vue&type=script&lang=js"
export * from "./NftMallSortFilter.vue?vue&type=script&lang=js"
import style0 from "./NftMallSortFilter.vue?vue&type=style&index=0&id=60d932be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d932be",
  null
  
)

export default component.exports